@if (
	{
		art: article$ | async,
		featured: featuredArticles$ | async,
	};
	as data
) {
	<uc-article-container
		[loadingAnimation]="loadingHtml"
		[loadingArticle]="loadingArticle"
		[article]="article"
		[categoryKey]="categoryKey"
		[articleCategoryUrl]="articleCategoryUrl"
		[featuredArticles]="data.featured"
		[articleCategory]="articleCategory"
		[url]="url"
	/>
}
<div id="ad_stop" class="container">
	<!-- snigel desktop -->
	<div class="hidden lg:block">
		<div class="adngin">
			<div id="adngin-incontent_1_dskt-0" class="mx-auto incontent_1_dskt-0"></div>
		</div>
	</div>
</div>

<uc-recommended-unis-carousel />

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
